// extracted by mini-css-extract-plugin
export default {"AuthPage":"BgPageContainer_AuthPage__uZyTK","containerAuthPage":"BgPageContainer_containerAuthPage__OHr3i"};